export const createReducer = (initialState, handlers) => {
    return (state = initialState, action) => {
        if (handlers.hasOwnProperty(action.type)) {
            return handlers[action.type](state, action)
        } else {
            return state
        }
    }
}

export const pluralize = (term, array) =>
    array.length <= 1 ? term : `${term}s`

export const TIMESTAMP_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export const byIdAndValues = (array, defaults = {}) => {
    return array.reduce(
        (agg, el) => ({
            byId: { ...agg.byId, [el.id]: { ...el, ...defaults } },
            values: [...agg.values, el.id],
        }),
        {
            byId: {},
            values: [],
        }
    )
}
